import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline'
import { useTranslation } from 'react-i18next'

import { getSummary } from './rozmowaDetailsHelpers'

export default function RozmowaSummarySection({ rozmowa }) {
	const { t } = useTranslation()
	const summary = getSummary(rozmowa)

	return (
		<div className="mb-5 rounded-md border border-slate-200 bg-white shadow-sm">
			<div className="border-b border-slate-300 bg-gray-100 px-6 py-3">
				<h2 className="flex items-center gap-2 text-lg font-semibold text-slate-900">
					<ClipboardDocumentListIcon className="h-5 w-5 text-sky-700" />
					<span>{t('conversations.details.summary.title')}</span>
				</h2>
			</div>
			<div className="px-6 py-4">
				<p className="whitespace-pre-wrap text-sm leading-relaxed text-gray-700">
					{summary || t('conversations.details.summary.empty')}
				</p>
			</div>
		</div>
	)
}
